/**
 * KV 入場アニメーション（preloader の kv:ready イベントを受けて発火）
 */
const _playEntrance = (el) => {
  const label    = el.querySelector('.c-visual__copy-label');
  const enEl     = el.querySelector('.c-visual__copy-en');
  const ja       = el.querySelector('.c-visual__copy-ja');
  const lead     = el.querySelector('.c-visual__copy-lead');
  const cta      = el.querySelector('.c-visual__copy-cta');
  const badge    = el.querySelector('.c-visual__badge');
  const side     = el.querySelector('.c-visual__side');
  const scrollEl = el.querySelector('.c-visual__scroll');

  // "CRAFT THE FUTURE." を1文字ずつ span に分割
  let chars = [];
  if (enEl) {
    enEl.innerHTML = enEl.textContent.split('').map((char) =>
      char === ' '
        ? '<span style="display:inline-block;width:0.3em"> </span>'
        : `<span style="display:inline-block">${char}</span>`
    ).join('');
    chars = Array.from(enEl.querySelectorAll('span'));
  }

  // 初期状態（すべて非表示）
  gsap.set([label, ja, lead, cta].filter(Boolean), { opacity: 0, y: 28 });
  gsap.set(chars, { opacity: 0, x: -14 });
  gsap.set([badge, side, scrollEl].filter(Boolean), { opacity: 0 });

  // タイムライン（シャッターが開き始めてから少し待って発火）
  const tl = gsap.timeline({ delay: 0.45 });

  tl.to(label, { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out' })
    .to(chars,  { opacity: 1, x: 0, duration: 0.4, stagger: 0.03, ease: 'power3.out' }, '-=0.25')
    .to(ja,     { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out' }, '-=0.2')
    .to(lead,   { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out' }, '-=0.3')
    .to(cta,    { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out' }, '-=0.25')
    .to([badge, side].filter(Boolean), { opacity: 1, duration: 0.5, stagger: 0.1, ease: 'power2.out' }, '-=0.1')
    .to(scrollEl, { opacity: 1, duration: 0.5, ease: 'power2.out' }, '-=0.1')
    // スクロールインジケーターをループバウンス
    .add(() => {
      if (scrollEl) {
        gsap.to(scrollEl, {
          y: 8,
          duration: 1.4,
          ease: 'sine.inOut',
          yoyo: true,
          repeat: -1,
        });
      }
    });
};

/**
 * #visual スクロールで暗転 + パララックス + 入場アニメーション
 */
let start = () => {
  const el = document.querySelector('#visual');
  if (!el) return;

  // スクロール：暗転 + ぼかし + 下にスライド
  const isMobile = window.innerWidth < 768;
  gsap.to(el, {
    opacity: 0.2,
    filter: 'blur(12px)',
    y: isMobile ? 400 : 800,
    ease: 'none',
    scrollTrigger: {
      trigger: el,
      start: 'top top',
      end: 'bottom top',
      scrub: true,
    },
  });

  // preloader がシャッターを開けた瞬間に入場アニメーション発火
  document.addEventListener('kv:ready', () => _playEntrance(el), { once: true });
};

/**
 * 初期化
 */
let init = () => {};

export default { init, start };
